// extracted by mini-css-extract-plugin
export default {"main_container":"Houses_main_container__z3Wfd","main_header":"Houses_main_header__4x4La","divider_home":"Houses_divider_home__Npvm8"};